import { LazyLoadImage } from 'react-lazy-load-image-component';
import styled from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

import { SectionTitle } from '~/src/features/mania/styled';

export const HassleBlock = styled.section`
    position: relative;
    height: 560px;
    display: flex;
    align-items: center;
    margin-bottom: 80px;

    @media (max-width: ${wideBreakpoints.sDesktop}) {
        height: 440px;
        margin-bottom: 150px;
    }

    @media (max-width: ${wideBreakpoints.laptop}) {
        height: 320px;
        margin-bottom: 120px;
    }

    @media (max-width: ${wideBreakpoints.tablet}) {
        margin-bottom: 54px;
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        height: auto;
        margin-bottom: 20px;
    }
`;

export const HassleContent = styled.div`
    flex-direction: column;
    flex-wrap: nowrap;
    max-width: 570px;

    @media (max-width: ${wideBreakpoints.sDesktop}) {
        max-width: 485px;
    }

    @media (max-width: ${wideBreakpoints.laptop}) {
        max-width: 450px;
    }

    @media (max-width: ${wideBreakpoints.tablet}) {
        max-width: 250px;
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        max-width: 45vw;
    }
`;

export const HassleTitle = styled(SectionTitle)`
    margin-bottom: 16px;

    @media (max-width: ${wideBreakpoints.mobile}) {
        margin-bottom: 8px;
    }
`;

export const HassleDesc = styled.p`
    ${FONTS.L};

    @media (max-width: ${wideBreakpoints.sDesktop}) {
        ${FONTS.M};
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        ${FONTS.S};
    }
`;

export const HassleImageBlock = styled.div`
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    width: 940px;
    background-color: red;
    border-radius: 500px 0 0 500px;
    overflow: hidden;

    @media (max-width: ${wideBreakpoints.sDesktop}) {
        width: 730px;
        border-radius: 400px 0 0 400px;
    }

    @media (max-width: ${wideBreakpoints.laptop}) {
        width: 500px;
        border-radius: 300px 0 0 300px;
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        top: 50%;
        transform: translateY(-50%);
        border-radius: 100px 0 0 100px;
        max-width: 170px;
        height: 100%;
        max-height: 180px;
    }
`;

export const HassleImage = styled(LazyLoadImage)`
    width: 100%;
    height: 100%;
    object-position: center;
    object-fit: cover;

    @media (max-width: ${wideBreakpoints.tablet}) {
        object-position: left;
    }
`;
